var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 120,
    viewBox: "0 0 193 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4316 24.9202C52.6959 24.9202 51.2852 23.5095 51.2852 21.7738V11.7362C51.2852 2.45946 61.5664 0.00732422 67.0099 0.00732422H149.785C151.52 0.00732422 152.931 1.41804 152.931 3.15375C152.931 4.88945 151.52 6.30017 149.785 6.30017H67.0099C66.9213 6.30017 57.578 6.41096 57.578 11.7362V21.7738C57.578 23.5095 56.1747 24.9202 54.4316 24.9202Z",
    fill: "#2777B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.997 103.042C187.261 103.042 185.85 101.631 185.85 99.8954V11.6551C185.828 11.1602 185.355 6.29286 176.308 6.29286H143.787C142.051 6.29286 140.641 4.88214 140.641 3.14643C140.641 1.41073 142.051 0 143.787 0H176.308C188.834 0 192.15 7.62233 192.15 11.6551V99.8954C192.143 101.638 190.732 103.042 188.997 103.042Z",
    fill: "#2777B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.426 120H67.0103C54.5724 120 51.293 112.326 51.293 108.271V95.7148C51.293 93.9791 52.7037 92.5684 54.4394 92.5684C56.1751 92.5684 57.5858 93.9791 57.5858 95.7148V108.271C57.6228 109.128 58.2506 113.707 67.0103 113.707H176.426C176.515 113.707 185.858 113.596 185.858 108.271V99.164C185.858 97.4283 187.269 96.0176 189.005 96.0176C190.74 96.0176 192.151 97.4283 192.151 99.164V108.271C192.144 117.548 181.862 120 176.426 120Z",
    fill: "#2777B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2676 67.7959C45.3546 64.1989 40.8935 62.8399 37.2965 64.7455L6.79979 80.9577C3.20282 82.8707 1.84381 87.3318 3.74939 90.9288C5.66236 94.5257 10.1235 95.8848 13.7205 93.9792L44.2172 77.7669C47.8141 75.854 49.1805 71.3928 47.2676 67.7959Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2784 97.7309C6.60018 97.7309 3.04753 95.7514 1.20103 92.2874C-1.45792 87.2945 0.447656 81.0681 5.44058 78.4092L35.9373 62.1969C38.3599 60.9118 41.1296 60.6385 43.7516 61.4436C46.3737 62.2412 48.523 64.0213 49.8082 66.4365C52.4597 71.4294 50.5541 77.6558 45.5612 80.3147L15.0645 96.527C13.5504 97.3468 11.9033 97.7309 10.2784 97.7309ZM40.7529 66.7762C40.0291 66.7762 39.3127 66.9535 38.6553 67.3006L8.15862 83.5128C5.97976 84.6724 5.14514 87.3905 6.30474 89.5768C7.46433 91.7556 10.1824 92.5828 12.3612 91.4306L42.8579 75.2184C45.0368 74.0588 45.8714 71.3408 44.7118 69.1545C44.1505 68.0983 43.2125 67.3228 42.0676 66.9757C41.6393 66.8353 41.1961 66.7762 40.7529 66.7762Z",
    fill: "#2777B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9427 71.1634L24.6909 73.4248L29.5988 82.6521L33.8505 80.3907L28.9427 71.1634Z",
    fill: "#2777B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8818 87.5316C78.6139 87.5316 91.3695 74.776 91.3695 59.0439C91.3695 43.3117 78.6139 30.5562 62.8818 30.5562C47.1496 30.5562 34.394 43.3117 34.394 59.0439C34.394 74.776 47.1496 87.5316 62.8818 87.5316Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8815 90.4192C45.5835 90.4192 31.5059 76.3416 31.5059 59.0436C31.5059 41.7457 45.5835 27.668 62.8815 27.668C80.1795 27.668 94.2571 41.7457 94.2571 59.0436C94.2571 76.3416 80.1795 90.4192 62.8815 90.4192ZM62.8815 33.4438C48.7669 33.4438 37.2817 44.929 37.2817 59.0362C37.2817 73.1508 48.7669 84.636 62.8815 84.636C76.9961 84.636 88.4739 73.1582 88.4739 59.0362C88.4739 44.929 76.9961 33.4438 62.8815 33.4438Z",
    fill: "#2777B8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3246 41.0513C54.5134 42.2035 50.9977 44.5005 48.3609 47.8833C45.9161 51.015 44.5497 54.6489 44.21 58.3345",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.21 61.2226C44.1213 61.2226 44.0327 61.2153 43.9441 61.2079C42.3561 61.0602 41.1817 59.6568 41.3294 58.0688C41.7283 53.7111 43.3754 49.575 46.086 46.1035C49.0109 42.3589 52.955 39.6556 57.4973 38.2818C59.0262 37.8239 60.6364 38.688 61.1017 40.2169C61.567 41.7458 60.6955 43.356 59.174 43.8213C55.7838 44.8405 52.8368 46.8643 50.6505 49.6636C48.6268 52.2561 47.4007 55.3508 47.0979 58.6006C46.9428 60.1 45.6872 61.2226 44.21 61.2226Z",
    fill: "#2777B8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 28,
    width: 66,
    height: 6,
    rx: 3,
    fill: "#2777B8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 42,
    width: 66,
    height: 6,
    rx: 3,
    fill: "#2777B8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 56,
    width: 66,
    height: 6,
    rx: 3,
    fill: "#2777B8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 70,
    width: 66,
    height: 6,
    rx: 3,
    fill: "#2777B8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 84,
    width: 66,
    height: 6,
    rx: 3,
    fill: "#2777B8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.228b57a68d3bc52f58b7a076bb92d162.svg";
export { ForwardRef as ReactComponent };